<template>
  <v-form v-model="valid" @submit.prevent ref="form">
    <v-row no-gutters>
      <v-container class="px-8">
        <h2 :class="$vuetify.breakpoint.smAndDown ? 'white--text' : 'primary-custom'">
          Olá, bem vindo ao seu aplicativo de saúde
        </h2>
        <h4 :class="$vuetify.breakpoint.smAndDown ? 'white--text' : 'font-weight-light'" class="mt-5">
          {{
            loginType === 'cpf'
              ? 'Para liberar sua guia de exame digite seu CPF abaixo:'
              : 'Para liberar sua guia de exame digite seu e-mail abaixo:'
          }}
        </h4>
        <v-text-field
          v-if="loginType === 'cpf'"
          key="cpf-input"
          v-model="identifier"
          color="loginTheme"
          :solo="$vuetify.breakpoint.smAndDown"
          :rules="cpfRules"
          class="mt-8"
          label="CPF"
          v-mask="'###.###.###-##'"
          outlined
          data-cpf
          autocomplete="off"
        ></v-text-field>
        <v-text-field
          v-else
          key="email-input"
          v-model="identifier"
          @keydown.space.prevent
          color="loginTheme"
          :solo="$vuetify.breakpoint.smAndDown"
          :rules="emailRules"
          class="mt-8"
          label="E-mail"
          type="email"
          outlined
          data-email
          autocomplete="off"
        ></v-text-field>
        <v-btn
          @click="$emit('on-submit')"
          :outlined="$vuetify.breakpoint.smAndDown"
          :color="$vuetify.breakpoint.smAndDown ? 'white' : 'loginTheme'"
          type="submit"
          block
          large
          rounded
          dark
          class="mb-3"
          >Continuar</v-btn
        >
        <v-btn
          @click="handleToggleLoginType"
          text
          block
          :color="$vuetify.breakpoint.smAndDown ? 'white' : 'loginTheme'"
          small
        >
          {{ loginType === 'cpf' ? 'Acessar com e-mail' : 'Acessar com CPF' }}
        </v-btn>
      </v-container>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    loginType: {
      type: String,
      default: 'cpf',
      validator: value => ['cpf', 'email'].includes(value)
    }
  },
  data: () => ({
    valid: false,
    cpfRules: [
      v => !!v || 'CPF é obrigatório',
      v => (v && v.replace(/\D/g, '').length === 11) || 'CPF deve ter 11 dígitos'
    ],
    emailRules: [v => !!v || 'E-mail é obrigatório', v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido']
  }),
  computed: {
    identifier: {
      get() {
        return this.value
      },
      set(value) {
        let formattedValue = value || ''

        if (this.loginType === 'email' && formattedValue) {
          formattedValue = formattedValue.toLowerCase().replace(/\s/g, '')
        }

        this.$emit('input', formattedValue)
      }
    }
  },
  watch: {
    loginType() {
      // Reseta o formulário quando o tipo de login muda
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    handleToggleLoginType() {
      // Reseta validações antes de emitir o evento
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.$emit('toggle-login-type')
    }
  }
}
</script>

<style>
.primary-custom {
  color: var(--v-loginTheme-base) !important;
}
</style>
